import React, {FunctionComponent, PropsWithChildren} from 'react';
import Description from "./Description";


export default function Header({ badgeText, children, component: Component, className, icon: Icon, id }: PropsWithChildren<{
    className?: string;
    id?: '';
    badgeText?: '';
    icon?: FunctionComponent<{ size: number; className: string }>;
    component: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}>) {
    return (
        <>
            {badgeText && (
                <div className="bg-lightest rounded-3 gray-600 text-sm d-inline-block py-2 px-4 mb-2">
                    {badgeText}
                </div>
            )}
            <div className={Icon ? 'd-flex justify-content-start align-items-center mb-3' : 'mb-3' }>
                {Icon && <Icon size={36} className="me-3" />}
                <Component className={className} id={id}>{children}</Component>
            </div>
        </>
    );
}

function AdminHeader({ badgeText, children, component: Component = 'h1', className, icon: Icon, id, description }: PropsWithChildren<{
    className?: string;
    id?: '';
    badgeText?: '';
    icon?: FunctionComponent<{ size: number; className: string }>;
    component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    description?: string | React.JSX.Element;
}>) {
    return (
      <>
          {badgeText && (
            <div className="bg-lightest rounded-3 gray-600 text-sm d-inline-block py-2 px-4 mb-2">
                {badgeText}
            </div>
          )}
          <div className="mb-3">
              <div className={Icon ? 'd-flex justify-content-start align-items-center' : '' }>
                  {Icon && <Icon size={36} className="me-3" />}
                  <Component className={className} id={id}>{children}</Component>
              </div>
              {description && <Description className="neutral-500">{description}</Description>}
          </div>
      </>
    );
}

Header.Admin = AdminHeader;
